import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const categoryData = [
    { name: 'Streaming', value: 35 },
    { name: 'Software', value: 25 },
    { name: 'Food Delivery', value: 20 },
    { name: 'Cloud Storage', value: 15 },
    { name: 'Others', value: 5 },
];

const COLORS = ['#4F46E5', '#06B6D4', '#10B981', '#FBBF24', '#6B7280'];

const CategoriesTab = () => {
    return (
        <div className="space-y-6">
            {/* Category Distribution Chart */}
            <div className="bg-white rounded-lg p-6 shadow-md">
                <h3 className="text-lg font-semibold mb-2">Spending by Category</h3>
                <p className="text-sm text-gray-500 mb-4">Breakdown of your subscription expenses by category</p>
                <div className="h-[300px] w-full">
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={categoryData}
                                cx="50%"
                                cy="50%"
                                labelLine={false}
                                outerRadius={100}
                                fill="#8884d8"
                                dataKey="value"
                                label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                            >
                                {categoryData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip formatter={(value) => `${value}%`} />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </div>

            {/* Top Expenses by Category */}
            <div className="bg-white rounded-lg p-6 shadow-md">
                <h3 className="text-lg font-semibold mb-4">Top Expenses by Category</h3>
                <div className="space-y-4">
                    {[
                        { category: "Streaming", name: "Netflix", amount: 15.99 },
                        { category: "Software", name: "Adobe Creative Cloud", amount: 52.99 },
                        { category: "Food Delivery", name: "DoorDash", amount: 9.99 },
                        { category: "Cloud Storage", name: "Google One", amount: 9.99 },
                    ].map((item, index) => (
                        <div key={index} className="flex items-center justify-between py-2 border-b last:border-0">
                            <div>
                                <p className="font-medium">{item.category}</p>
                                <p className="text-sm text-gray-500">{item.name}</p>
                            </div>
                            <span className="font-semibold">${item.amount}/mo</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CategoriesTab;